{
  "identities.messages.1010001": "ลงชื่อเข้าใช้",
  "identities.messages.1010002": "ลงชื่อเข้าใช้ด้วย {provider}",
  "identities.messages.1010003": "โปรดยืนยันการกระทำนี้โดยตรวจสอบว่าเป็นคุณ",
  "identities.messages.1010004": "โปรดดำเนินการตรวจสอบยืนยันอีกขั้นตอนหนึ่ง",
  "identities.messages.1010005": "ตรวจสอบความถูกต้อง",
  "identities.messages.1010006": "รหัสการตรวจสอบความถูกต้อง",
  "identities.messages.1010007": "รหัสการกู้คืนสำรอง",
  "identities.messages.1010008": "ดำเนินการต่อด้วยฮาร์ดแวร์คีย์",
  "identities.messages.1010009": "ดำเนินการต่อ",
  "identities.messages.1010010": "ดำเนินการต่อ",
  "identities.messages.1010011": "ลงชื่อเข้าใช้ด้วยฮาร์ดแวร์คีย์",
  "identities.messages.1010012": "เตรียมอุปกรณ์ WebAuthn ของคุณ (เช่น คีย์ความปลอดภัย สแกนนิ้วมือ ฯลฯ) และกดปุ่มดำเนินการต่อ",
  "identities.messages.1010013": "ดำเนินการต่อ",
  "identities.messages.1010014": "มีการส่งรหัสไปยังที่อยู่ที่คุณให้ไว้ หากคุณยังไม่ได้รับ โปรดตรวจสอบการสะกดของที่อยู่และลองอีกครั้ง",
  "identities.messages.1010015": "ส่งรหัสการลงชื่อเข้าใช้",
  "identities.messages.1010016": "คุณพยายามลงชื่อเข้าใช้ด้วย \"{duplicateIdentifier}\" แต่อีเมลนี้ถูกใช้โดยบัญชีอื่นอยู่แล้ว ลงชื่อเข้าใช้บัญชีของคุณด้วยหนึ่งในตัวเลือกต่อไปนี้เพื่อเพิ่มบัญชีของคุณ \"{duplicateIdentifier}\" ที่ \"{provider}\" เป็นอีกวิธีหนึ่งในการลงชื่อเข้าใช้",
  "identities.messages.1010017": "ลงชื่อเข้าใช้และเชื่อมโยง",
  "identities.messages.1010018": "ยืนยันด้วย {provider}",
  "identities.messages.1010019": "ขอรหัสเพื่อดำเนินการต่อ",
  "identities.messages.1010021": "ลงชื่อเข้าใช้ด้วย Passkey",
  "identities.messages.1010022": "ลงชื่อเข้าใช้ด้วยรหัสผ่าน",
  "identities.messages.1010023": "ส่งรหัสไปยัง {address}",
  "identities.messages.1040001": "ลงทะเบียน",
  "identities.messages.1040002": "ลงทะเบียนด้วย {provider}",
  "identities.messages.1040003": "ดำเนินการต่อ",
  "identities.messages.1040004": "ลงทะเบียนด้วยคีย์ความปลอดภัย",
  "identities.messages.1040005": "มีการส่งรหัสไปยังที่อยู่ (ที่อยู่) ที่คุณให้ไว้ หากคุณยังไม่ได้รับข้อความ โปรดตรวจสอบการสะกดของที่อยู่และลองลงทะเบียนอีกครั้ง",
  "identities.messages.1040006": "ส่งรหัสการลงทะเบียน",
  "identities.messages.1040007": "ลงทะเบียนด้วย Passkey",
  "identities.messages.1040008": "ย้อนกลับ",
  "identities.messages.1040009": "โปรดเลือกข้อมูลประจำตัวเพื่อยืนยันตัวตนของคุณ",
  "identities.messages.1050001": "การเปลี่ยนแปลงของคุณถูกบันทึกแล้ว!",
  "identities.messages.1050002": "เชื่อมโยง {provider}",
  "identities.messages.1050003": "ยกเลิกการเชื่อมโยง {provider}",
  "identities.messages.1050004": "ยกเลิกการเชื่อมโยงแอปยืนยัน TOTP",
  "identities.messages.1050005": "รหัส QR ของแอปยืนยันตัวตน",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "แสดงรหัสการกู้คืนสำรอง",
  "identities.messages.1050008": "เปิดใช้งาน",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "นี่คือรหัสการกู้คืนสำรองของคุณ โปรดเก็บไว้ในที่ปลอดภัย!",
  "identities.messages.1050011": "ยืนยันรหัสการกู้คืนสำรอง",
  "identities.messages.1050012": "เพิ่มคีย์ความปลอดภัย",
  "identities.messages.1050013": "ชื่อของคีย์ความปลอดภัย",
  "identities.messages.1050014": "รหัสลับถูกใช้ที่ {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "ปิดการใช้งานวิธีนี้",
  "identities.messages.1050017": "รหัสลับสำหรับการยืนยันตัวตน",
  "identities.messages.1050018": "ลบคีย์ความปลอดภัย \"{display_name}\"",
  "identities.messages.1050019": "เพิ่ม Passkey",
  "identities.messages.1050020": "ลบ Passkey \"{display_name}\"",
  "identities.messages.1060001": "คุณกู้คืนบัญชีของคุณสำเร็จแล้ว โปรดเปลี่ยนรหัสผ่านหรือตั้งค่าวิธีเข้าสู่ระบบอื่น (เช่น การลงชื่อเข้าใช้ผ่านโซเชียลมีเดีย) ภายใน {privileged_session_expires_at_unix_until_minutes} นาที",
  "identities.messages.1060002": "อีเมลที่มีลิงก์การกู้คืนถูกส่งไปยังที่อยู่อีเมลที่คุณให้ไว้ หากคุณยังไม่ได้รับอีเมล โปรดตรวจสอบการสะกดของที่อยู่และแน่ใจว่าคุณใช้ที่อยู่ที่คุณลงทะเบียนไว้",
  "identities.messages.1060003": "อีเมลที่มีรหัสการกู้คืนถูกส่งไปยังที่อยู่อีเมลที่คุณให้ไว้ หากคุณยังไม่ได้รับอีเมล โปรดตรวจสอบการสะกดของที่อยู่และแน่ใจว่าคุณใช้ที่อยู่ที่คุณลงทะเบียนไว้",
  "identities.messages.1060004": "มีการส่งรหัสการกู้คืนไปยัง \"{masked_address}\" หากคุณยังไม่ได้รับ โปรดตรวจสอบการสะกดของที่อยู่และแน่ใจว่าคุณใช้ที่อยู่ที่คุณลงทะเบียนไว้",
  "identities.messages.1060005": "กู้คืนการเข้าถึงบัญชีของคุณโดยให้ที่อยู่การกู้คืนทั้งหมด",
  "identities.messages.1060006": "คุณต้องการกู้คืนบัญชีของคุณอย่างไร?",
  "identities.messages.1060007": "ย้อนกลับ",
  "identities.messages.1070001": "รหัสผ่าน",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "บันทึก",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "ส่ง",
  "identities.messages.1070006": "ตรวจสอบรหัส",
  "identities.messages.1070007": "อีเมล",
  "identities.messages.1070008": "ส่งใหม่",
  "identities.messages.1070009": "ดำเนินการต่อ",
  "identities.messages.1070010": "รหัสการกู้คืน",
  "identities.messages.1070011": "รหัสการตรวจสอบ",
  "identities.messages.1070012": "รหัสการลงทะเบียน",
  "identities.messages.1070013": "รหัสการเข้าสู่ระบบ",
  "identities.messages.1070014": "เข้าสู่ระบบและเชื่อมโยงข้อมูลประจำตัว",
  "identities.messages.1070015": "โปรดดำเนินการท้าทาย Captcha เพื่อดำเนินการต่อ",
  "identities.messages.1070016": "ที่อยู่การกู้คืน",
  "identities.messages.1070017": "เบอร์โทรศัพท์",
  "identities.messages.1080001": "อีเมลที่มีลิงก์การตรวจสอบถูกส่งไปยังที่อยู่อีเมลที่คุณให้ไว้ หากคุณยังไม่ได้รับอีเมล โปรดตรวจสอบการสะกดของที่อยู่และแน่ใจว่าคุณใช้ที่อยู่ที่คุณลงทะเบียนไว้",
  "identities.messages.1080002": "คุณตรวจสอบที่อยู่อีเมลของคุณสำเร็จแล้ว",
  "identities.messages.1080003": "อีเมลที่มีรหัสการตรวจสอบถูกส่งไปยังที่อยู่อีเมลที่คุณให้ไว้ หากคุณยังไม่ได้รับอีเมล โปรดตรวจสอบการสะกดของที่อยู่และแน่ใจว่าคุณใช้ที่อยู่ที่คุณลงทะเบียนไว้",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "โปรดป้อน {property} และลองอีกครั้ง",
  "identities.messages.4000003": "ความยาวต้องมากกว่าหรือเท่ากับ {min_length} แต่ได้ {actual_length}",
  "identities.messages.4000004": "ไม่ตรงกับรูปแบบ \"{pattern}\"",
  "identities.messages.4000005": "ไม่สามารถใช้รหัสผ่านนี้ได้เนื่องจาก {reason}",
  "identities.messages.4000006": "ข้อมูลประจำตัวที่ให้มาไม่ถูกต้อง โปรดตรวจสอบการสะกดของรหัสผ่าน ชื่อผู้ใช้ อีเมล หรือเบอร์โทรศัพท์ของคุณ",
  "identities.messages.4000007": "มีบัญชีที่มีตัวระบุเดียวกัน (อีเมล เบอร์โทรศัพท์ ชื่อผู้ใช้ ฯลฯ) อยู่แล้ว",
  "identities.messages.4000008": "รหัสการยืนยันที่ให้มาไม่ถูกต้อง โปรดลองอีกครั้ง",
  "identities.messages.4000009": "ไม่สามารถหาตัวระบุการเข้าสู่ระบบใด ๆ ได้ คุณลืมตั้งค่าหรือไม่? ปัญหานี้อาจเกิดจากความผิดพลาดของเซิร์ฟเวอร์",
  "identities.messages.4000010": "บัญชียังไม่ถูกใช้งาน คุณลืมตรวจสอบอีเมลของคุณหรือไม่?",
  "identities.messages.4000011": "คุณยังไม่ได้ตั้งค่าอุปกรณ์ TOTP",
  "identities.messages.4000012": "รหัสการกู้คืนสำรองนี้ถูกใช้ไปแล้ว",
  "identities.messages.4000013": "คุณยังไม่ได้ตั้งค่าอุปกรณ์ WebAuthn",
  "identities.messages.4000014": "คุณยังไม่ได้ตั้งค่ารหัสการกู้คืนสำรอง",
  "identities.messages.4000015": "บัญชีนี้ไม่มีอยู่หรือยังไม่ได้ตั้งค่าคีย์ความปลอดภัย",
  "identities.messages.4000016": "รหัสการกู้คืนสำรองนี้ไม่ถูกต้อง",
  "identities.messages.4000017": "ความยาวต้องน้อยกว่าหรือเท่ากับ {max_length} แต่ได้ {actual_length}",
  "identities.messages.4000018": "ต้องมากกว่าหรือเท่ากับ {minimum} แต่ได้ {actual}",
  "identities.messages.4000019": "ต้องมากกว่า {minimum} แต่ได้ {actual}",
  "identities.messages.4000020": "ต้องน้อยกว่าหรือเท่ากับ {maximum} แต่ได้ {actual}",
  "identities.messages.4000021": "ต้องน้อยกว่า {maximum} แต่ได้ {actual}",
  "identities.messages.4000022": "{actual} ไม่ใช่ค่าที่เป็นพหุคูณของ {base}",
  "identities.messages.4000023": "อนุญาตให้สูงสุด {max_items} รายการ แต่ได้ {actual_items} รายการ",
  "identities.messages.4000024": "ต้องมีอย่างน้อย {min_items} รายการ แต่ได้ {actual_items} รายการ",
  "identities.messages.4000025": "รายการที่ดัชนี {index_a} และ {index_b} เท่ากัน",
  "identities.messages.4000026": "คาดว่าจะได้ {allowed_types_list} แต่ได้ {actual_type}",
  "identities.messages.4000027": "มีบัญชีที่มีตัวระบุเดียวกัน (อีเมล เบอร์โทรศัพท์ ชื่อผู้ใช้ ฯลฯ) อยู่แล้ว โปรดลงชื่อเข้าใช้บัญชีของคุณเพื่อเชื่อมโยงโปรไฟล์โซเชียลของคุณ",
  "identities.messages.4000028": "คุณพยายามลงชื่อเข้าใช้ด้วย {credential_identifier_hint} ซึ่งถูกใช้โดยบัญชีอื่นอยู่แล้ว คุณสามารถลงชื่อเข้าใช้โดยใช้ {available_credential_types_list} คุณสามารถลงชื่อเข้าใช้โดยใช้ผู้ให้บริการการลงชื่อเข้าใช้ผ่านโซเชียลมีเดียต่อไปนี้: {available_oidc_providers_list}",
  "identities.messages.4000029": "ต้องเท่ากับค่าคงที่ {expected}",
  "identities.messages.4000030": "การตรวจสอบค่าคงที่ล้มเหลว",
  "identities.messages.4000031": "ไม่สามารถใช้รหัสผ่านนี้ได้เนื่องจากมันคล้ายกับตัวระบุเกินไป",
  "identities.messages.4000032": "รหัสผ่านต้องมีความยาวอย่างน้อย {min_length} ตัวอักษร แต่ได้ {actual_length}",
  "identities.messages.4000033": "รหัสผ่านต้องมีความยาวไม่เกิน {max_length} ตัวอักษร แต่ได้ {actual_length}",
  "identities.messages.4000034": "รหัสผ่านนี้ถูกพบในเหตุการณ์การรั่วไหลข้อมูลและไม่สามารถใช้งานได้อีกต่อไป",
  "identities.messages.4000035": "บัญชีนี้ไม่มีอยู่หรือยังไม่ได้ตั้งค่าการเข้าสู่ระบบด้วยรหัส",
  "identities.messages.4000036": "ข้อมูลประจำตัวที่ให้มาไม่ตรงกับข้อมูลประจำตัวที่เชื่อมโยงกับการดำเนินการนี้",
  "identities.messages.4000037": "บัญชีนี้ไม่มีอยู่หรือยังไม่ได้ตั้งค่าวิธีการเข้าสู่ระบบ",
  "identities.messages.4000038": "การตรวจสอบ Captcha ล้มเหลว โปรดลองอีกครั้ง",
  "identities.messages.4010001": "การดำเนินการเสร็จสิ้นแล้ว โปรดลองใหม่อีกครั้ง",
  "identities.messages.4010002": "ไม่สามารถหาวิธีการเข้าสู่ระบบสำหรับคุณได้ คุณกรอกแบบฟอร์มถูกต้องหรือไม่?",
  "identities.messages.4010003": "ไม่สามารถหาวิธีการลงทะเบียนสำหรับคุณได้ คุณกรอกแบบฟอร์มถูกต้องหรือไม่?",
  "identities.messages.4010004": "ไม่สามารถหาวิธีการปรับปรุงการตั้งค่าของคุณได้ คุณกรอกแบบฟอร์มถูกต้องหรือไม่?",
  "identities.messages.4010005": "ไม่สามารถหาวิธีการกู้คืนบัญชีของคุณได้ คุณกรอกแบบฟอร์2ถูกต้องหรือไม่?",
  "identities.messages.4010006": "ไม่สามารถหาวิธีการตรวจสอบบัญชีของคุณได้ คุณกรอกแบบฟอร์มถูกต้องหรือไม่?",
  "identities.messages.4010007": "คำขอถูกดำเนินการสำเร็จแล้วและไม่สามารถดำเนินการซ้ำได้",
  "identities.messages.4010008": "รหัสการเข้าสู่ระบบไม่ถูกต้องหรือถูกใช้ไปแล้ว โปรดลองอีกครั้ง",
  "identities.messages.4010009": "ข้อมูลประจำตัวที่เชื่อมโยงไม่ตรงกัน",
  "identities.messages.4010010": "ที่อยู่ที่คุณป้อนไม่ตรงกับที่อยู่ใด ๆ ที่รู้จักในบัญชีปัจจุบัน",
  "identities.messages.4040001": "การดำเนินการเสร็จสิ้นแล้ว โปรดลองใหม่อีกครั้ง",
  "identities.messages.4040002": "คำขอถูกดำเนินการสำเร็จแล้วและไม่สามารถดำเนินการซ้ำได้",
  "identities.messages.4040003": "รหัสการลงทะเบียนไม่ถูกต้องหรือถูกใช้ไปแล้ว โปรดลองอีกครั้ง",
  "identities.messages.4050001": "การดำเนินการเสร็จสิ้นแล้ว โปรดลองใหม่อีกครั้ง",
  "identities.messages.4060001": "คำขอถูกดำเนินการสำเร็จแล้วและไม่สามารถดำเนินการซ้ำได้",
  "identities.messages.4060002": "การดำเนินการกู้คืนบัญชีเข้าสู่สถานะล้มเหลวและต้องดำเนินการซ้ำ",
  "identities.messages.4060004": "โทเคนการกู้คืนไม่ถูกต้องหรือถูกใช้ไปแล้ว โปรดดำเนินการตามขั้นตอนอีกครั้ง",
  "identities.messages.4060005": "การดำเนินการเสร็จสิ้นแล้ว โปรดลองใหม่อีกครั้ง",
  "identities.messages.4060006": "รหัสการกู้คืนไม่ถูกต้องหรือถูกใช้ไปแล้ว โปรดลองอีกครั้ง",
  "identities.messages.4070001": "โทเคนการตรวจสอบไม่ถูกต้องหรือถูกใช้ไปแล้ว โปรดดำเนินการตามขั้นตอนอีกครั้ง",
  "identities.messages.4070002": "คำขอถูกดำเนินการสำเร็จแล้วและไม่สามารถดำเนินการซ้ำได้",
  "identities.messages.4070003": "การดำเนินการตรวจสอบเข้าสู่สถานะล้มเหลวและต้องดำเนินการซ้ำ",
  "identities.messages.4070005": "การดำเนินการเสร็จสิ้นแล้ว โปรดลองใหม่อีกครั้ง",
  "identities.messages.4070006": "รหัสการตรวจสอบไม่ถูกต้องหรือถูกใช้ไปแล้ว โปรดลองอีกครั้ง",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "ออกจากระบบ",
  "login.registration-button": "ลงทะเบียน",
  "login.registration-label": "ยังไม่มีบัญชี?",
  "login.title": "ลงชื่อเข้าใช้",
  "login.subtitle": "ลงชื่อเข้าใช้ด้วย {parts}",
  "login.title-aal2": "การยืนยันตัวตนขั้นที่สอง",
  "login.subtitle-aal2": "เลือกวิธีเพื่อเสร็จสิ้นการยืนยันตัวตนขั้นที่สองของคุณ",
  "login.code.subtitle": "รหัสการตรวจสอบจะถูกส่งทางอีเมล",
  "login.webauthn.subtitle": "โปรดเตรียมอุปกรณ์ WebAuthN ของคุณ",
  "login.totp.subtitle": "โปรดป้อนรหัสที่ถูกสร้างโดยแอปยืนยันตัวตนของคุณ",
  "login.lookup_secret.subtitle": "โปรดป้อนหนึ่งในรหัสการกู้คืนสำรอง 8 หลักของคุณ",
  "login.title-refresh": "ยืนยันตัวตนอีกครั้ง",
  "login.subtitle-refresh": "ยืนยันตัวตนของคุณด้วย {parts}",
  "login.2fa.go-back": "บางอย่างไม่ทำงาน?",
  "login.2fa.go-back.link": "ย้อนกลับ",
  "login.2fa.method.go-back": "เลือกวิธีอื่น",
  "recovery.title": "กู้คืนบัญชีของคุณ",
  "recovery.subtitle": "ป้อนตัวระบุที่เชื่อมโยงกับบัญชีของคุณเพื่อรับรหัสการเข้าสู่ระบบครั้งเดียว",
  "registration.login-button": "ลงชื่อเข้าใช้",
  "registration.login-label": "มีบัญชีอยู่แล้ว?",
  "registration.title": "ลงทะเบียนบัญชี",
  "registration.subtitle": "ลงทะเบียนด้วย {parts}",
  "settings.navigation-back-button": "ย้อนกลับ",
  "settings.subtitle": "อัปเดตการตั้งค่าบัญชีของคุณ",
  "settings.title": "การตั้งค่าบัญชี",
  "settings.password.title": "เปลี่ยนรหัสผ่าน",
  "settings.password.description": "ปรับปรุงรหัสผ่านของคุณ",
  "settings.profile.title": "การตั้งค่าโปรไฟล์",
  "settings.profile.description": "อัปเดตข้อมูลโปรไฟล์ของคุณ",
  "settings.webauthn.title": "จัดการโทเค็นฮาร์ดแวร์",
  "settings.webauthn.description": "จัดการการตั้งค่าโทเค็นฮาร์ดแวร์ของคุณ",
  "settings.messages.toast-title.success": "การตั้งค่าถูกอัปเดต",
  "settings.messages.toast-title.error": "ไม่สามารถอัปเดตการตั้งค่าได้",
  "verification.title": "ตรวจสอบบัญชีของคุณ",
  "verification.subtitle": "ป้อนที่อยู่อีเมลที่เชื่อมโยงกับบัญชีของคุณเพื่อตรวจสอบ",
  "two-step.password.title": "รหัสผ่าน",
  "two-step.password.description": "ป้อนรหัสผ่านที่เชื่อมโยงกับบัญชีของคุณ",
  "two-step.code.title": "รหัสอีเมล",
  "two-step.code.description": "รหัสการตรวจสอบจะถูกส่งไปยังอีเมลของคุณ",
  "two-step.webauthn.title": "คีย์ความปลอดภัย",
  "two-step.webauthn.description": "ใช้คีย์ความปลอดภัยของคุณเพื่อยืนยันตัวตน",
  "two-step.passkey.title": "Passkey (แนะนำ)",
  "two-step.passkey.description": "ใช้อุปกรณ์ของคุณสำหรับการสแกนนิ้วมือหรือใบหน้า",
  "two-step.passkey.description.error": "ไม่สามารถโหลดไลบรารีที่จำเป็นเพื่อใช้ Passkey ของคุณได้ โปรดลองอีกครั้งในภายหลัง",
  "two-step.totp.title": "ใช้แอปยืนยันตัวตนของคุณ (TOTP)",
  "two-step.totp.description": "ใช้รหัส 6 หลักจากแอปยืนยันตัวตนของคุณ",
  "two-step.lookup_secret.title": "รหัสการกู้คืนสำรอง",
  "two-step.lookup_secret.description": "ใช้หนึ่งในรหัสการกู้คืนสำรอง 8 หลักของคุณเพื่อยืนยันตัวตน",
  "input.placeholder": "ป้อน {placeholder} ของคุณ",
  "card.header.parts.oidc": "ผู้ให้บริการโซเชียล",
  "card.header.parts.password.registration": "{identifierLabel}และรหัสผ่านของคุณ",
  "card.header.parts.password.login": "{identifierLabel}และรหัสผ่านของคุณ",
  "card.header.parts.code": "รหัสครั้งเดียว",
  "card.header.parts.passkey": "Passkey",
  "card.header.parts.webauthn": "คีย์ความปลอดภัย",
  "card.header.parts.totp": "แอปยืนยันตัวตนของคุณ",
  "card.header.parts.lookup_secret": "รหัสการกู้คืนสำรอง",
  "card.header.parts.identifier-first": "{identifierLabel}ของคุณ",
  "misc.or": "หรือ",
  "forms.label.forgot-password": "ลืมรหัสผ่าน?",
  "forms.label.recover-account": "กู้คืนบัญชี",
  "settings.totp.title": "แอปยืนยันตัวตน",
  "settings.totp.description": "เพิ่มแอปยืนยันตัวตน TOTP ลงในบัญชีของคุณเพื่อเพิ่มความปลอดภัยของบัญชี แอปยืนยันตัวตนที่นิยมคือ LastPass และ Google Authenticator",
  "settings.totp.info.not-linked": "เพื่อเปิดใช้งาน ให้สแกนรหัส QR ด้วยแอปยืนยันตัวตนของคุณและป้อนรหัส",
  "settings.totp.info.linked": "คุณมีแอปยืนยันตัวตนเชื่อมโยงอยู่แล้ว",
  "settings.lookup_secret.title": "รหัสการกู้คืนสำรอง (ขั้นที่สอง)",
  "settings.lookup_secret.description": "รหัสการกู้คืนสำรองเป็นการสำรองที่ปลอดภัยสำหรับ 2FA ช่วยให้คุณสามารถกู้คืนการเข้าถึงบัญชีของคุณได้หากคุณสูญเสียอุปกรณ์ 2FA ของคุณ",
  "settings.oidc.title": "บัญชีที่เชื่อมโยง",
  "settings.oidc.description": "เชื่อมต่อบัญชีผู้ให้บริการโซเชียลกับบัญชีของคุณ",
  "settings.oidc.info": "บัญชีที่เชื่อมโยงจากผู้ให้บริการเหล่านี้สามารถใช้เพื่อเข้าสู่ระบบบัญชีของคุณ",
  "settings.webauthn.info": "โทเค็นฮาร์ดแวร์ถูกใช้สำหรับการยืนยันตัวตนขั้นที่สอง หรือเป็นขั้นแรกด้วย Passkeys",
  "settings.passkey.title": "จัดการ Passkeys",
  "settings.passkey.description": "จัดการการตั้งค่า Passkey ของคุณ",
  "settings.passkey.info": "จัดการการตั้งค่า Passkey ของคุณ",
  "card.footer.select-another-method": "เลือกวิธีอื่น",
  "account-linking.title": "เชื่อมโยงบัญชี",
  "property.password": "รหัสผ่าน",
  "property.email": "อีเมล",
  "property.phone": "เบอร์โทรศัพท์",
  "property.username": "ชื่อผู้ใช้",
  "property.identifier": "ตัวระบุ",
  "property.code": "รหัส",
  "property.recovery_address": "ที่อยู่การกู้คืน",
  "consent.title": "อนุญาตให้ {party}",
  "consent.subtitle": "แอปพลิเคชันของบุคคลที่สามต้องการเข้าถึงข้อมูลที่เชื่อมโยงกับบัญชีของคุณ {identifier}",
  "consent.scope.openid.title": "ข้อมูลตัวตน",
  "consent.scope.openid.description": "อนุญาตให้แอปพลิเคชันตรวจสอบตัวตนของคุณ นี่เป็นสิ่งจำเป็นสำหรับการยืนยันตัวตนและประสบการณ์การเข้าสู่ระบบที่เชื่อถือได้",
  "consent.scope.offline_access.title": "การเข้าถึงขณะออฟไลน์",
  "consent.scope.offline_access.description": "อนุญาตให้แอปพลิเคชันนี้สามารถเก็บคุณไว้ในสถานะเข้าสู่ระบบแม้คุณไม่ได้ใช้งานอย่างกระตือรือร้น",
  "consent.scope.profile.title": "ข้อมูลโปรไฟล์",
  "consent.scope.profile.description": "อนุญาตให้เข้าถึงข้อมูลโปรไฟล์พื้นฐานของคุณ รวมถึงชื่อผู้ใช้ ชื่อแรก และชื่อสุดท้ายของคุณ",
  "consent.scope.email.title": "ที่อยู่อีเมล",
  "consent.scope.email.description": "ดึงที่อยู่อีเมลและสถานะการตรวจสอบของมัน",
  "consent.scope.address.title": "ที่อยู่ทางกายภาพ",
  "consent.scope.address.description": "เข้าถึงที่อยู่ไปรษณีย์ของคุณ",
  "consent.scope.phone.title": "เบอร์โทรศัพท์",
  "consent.scope.phone.description": "ดึงเบอร์โทรศัพท์และสถานะการตรวจสอบของมัน",
  "error.title.what-happened": "เกิดอะไรขึ้น?",
  "error.title.what-can-i-do": "ฉันสามารถทำอะไรได้บ้าง?",
  "error.instructions": "โปรดลองอีกครั้งในไม่กี่นาทีหรือติดต่อผู้ดูแลเว็บไซต์",
  "error.footer.text": "เมื่อรายงานข้อผิดพลาดนี้ โปรดรวมข้อมูลต่อไปนี้:",
  "error.footer.copy": "คัดลอก",
  "error.action.go-back": "ย้อนกลับ",
  "identities.messages.4000039": "รหัสผ่านใหม่ต้องแตกต่างจากรหัสผ่านเก่า",
  "identities.messages.4000040": "ป้อนที่อยู่อีเมลที่ถูกต้อง",
  "identities.messages.4000041": "ป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
  "captcha.error": "การตรวจสอบความปลอดภัยล้มเหลว โปรดลองใหม่อีกครั้งในภายหลัง หากปัญหายังคงอยู่ โปรดติดต่อฝ่ายสนับสนุน",
  "identities.messages.5000002": "ขณะนี้ไม่มีวิธีการยืนยันตัวตน กรุณาติดต่อผู้ดูแลระบบ",
  "identities.messages.4010011": "บัญชีนี้ถูกปิดใช้งานแล้ว โปรดติดต่อฝ่ายสนับสนุนเพื่อขอความช่วยเหลือ",
  "identities.messages.1070018": "ที่อยู่อีเมลหรือหมายเลขโทรศัพท์",
  "identities.messages.1080004": "ข้อความสั้น (SMS) ที่มีรหัสยืนยันได้ถูกส่งไปยังหมายเลขโทรศัพท์ที่คุณให้ไว้ หากคุณยังไม่ได้รับข้อความ โปรดตรวจสอบว่าหมายเลขที่คุณป้อนถูกต้องหรือไม่ และตรวจสอบให้แน่ใจว่าคุณใช้หมายเลขโทรศัพท์ที่คุณลงทะเบียนไว้",
  "identities.messages.1080005": "คุณได้ตรวจสอบหมายเลขโทรศัพท์ของคุณเรียบร้อยแล้ว",
  "identities.messages.5000003": "องค์กรของท่านจำเป็นต้องใช้ระบบยืนยันตัวตนแบบรวมศูนย์ (SSO) แต่ยังไม่ได้ตั้งค่าผู้ให้บริการ SSO โปรดติดต่อผู้ดูแลระบบ",
  "identities.messages.1010024": "ลงชื่อเข้าใช้ด้วยคีย์ฮาร์ดแวร์",
  "identities.messages.1010025": "ส่งรหัสไปยังที่อยู่ของคุณแล้ว หากคุณไม่ได้รับ โปรดลองอีกครั้ง",
  "identities.messages.4000042": "ขณะนี้ยังไม่มีอุปกรณ์ DeviceAuthn ที่ตั้งค่าไว้",
  "identities.messages.4000043": "การลงชื่อเข้าใช้ผ่านระบบยืนยันตัวตนทางเว็บที่ให้มานั้นไม่ถูกต้อง โปรดลองใหม่อีกครั้ง",
  "identities.messages.4000044": "ลายเซ็น DeviceAuthn ที่ให้มาไม่ถูกต้อง",
  "identities.messages.4050002": "คุณสามารถเปลี่ยนแปลงที่อยู่ได้เพียงครั้งละหนึ่งรายการ โปรดแก้ไขที่อยู่แต่ละรายการแยกกัน"
}
